var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('two-factor-authentication-set-up-modal'),_c('authentication-recovery-codes-modal'),_c('authentication-scan-code-modal'),_c('authentication-manual-flow-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }